module.exports = __webpack_public_path__ + "static/media/logo.ac3fc9fe.svg";